import axiosClient from 'utils/axiosClient';
import api from 'api';

const getCertificationReports = async (data: any) => {
	const response = await axiosClient.get(api.REPORTS.CERTIFICATION_REPORTS, {params: data});
	return response.data;
};

// const getModuleGrades = async (id: number, data: any) => {
// 	const response = await axiosClient.get(`${api.REPORTS.REPORTS_MODULE}/${id}`, {params: data});
// 	return response.data;
// };

// const getModuleSubjectGrades = async (id: number, data: any) => {
// 	const response = await axiosClient.get(`${api.REPORTS.REPORTS_MODULE}/${id}/grades`, {params: data});
// 	return response.data;
// };

const service = {
	getCertificationReports
};

export default service;
